import script from "./MintCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MintCard.vue?vue&type=script&setup=true&lang=js"

import "./MintCard.vue?vue&type=style&index=0&id=4d1b7c28&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d1b7c28"]])

export default __exports__